import { Typo3Page } from '@/types'
import { Typo3Locales } from '@/types/typo3/locales'
import { Locale, i18n } from '@spot'
import { create } from 'zustand'
import createSelectors from '../utils/createSelectors'

interface State {
  currentLocale: Locale
  currentRoutes: Typo3Page['i18n'] | null
  dictionary: Typo3Locales
}
interface Action {
  setCurrentLocale: (currentLocale: State['currentLocale']) => void
  setCurrentRoutes: (currentRoutes: State['currentRoutes']) => void
  setDictionary: (dictionary: State['dictionary']) => void
  reset: () => void
}

const baseStoreI18n = create<State & Action>((set) => ({
  currentLocale: i18n.defaultLocale,
  currentRoutes: null,
  dictionary: {},
  setDictionary: (dictionary) => set(() => ({ dictionary })),
  reset: () =>
    set({
      currentLocale: i18n.defaultLocale,
      currentRoutes: null,
      dictionary: {}
    }),
  setCurrentLocale: (currentLocale) =>
    set(() => ({ currentLocale: currentLocale })),
  setCurrentRoutes: (currentRoutes) =>
    set(() => ({ currentRoutes: currentRoutes }))
}))

const useStoreI18n = createSelectors(baseStoreI18n)

export default useStoreI18n
